const LOCAL_SITE_ORIGIN = import.meta.env.VITE_SITE_ORIGIN || 'https://foxhurd.com'
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1'])

const getRuntimeOrigin = () => {
  if (typeof window === 'undefined') {
    return LOCAL_SITE_ORIGIN
  }

  return LOCAL_HOSTS.has(window.location.hostname) ? LOCAL_SITE_ORIGIN : window.location.origin
}

export const getSiteUrl = (path) => new URL(path, `${getRuntimeOrigin()}/`).toString()

export const resolveSiteUrl = (value) => {
  if (!value) return null

  try {
    return new URL(value, `${getRuntimeOrigin()}/`).toString()
  } catch {
    return value
  }
}
